import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import usePageColorScheme from '../../shared/hooks/usePageColorScheme';

const TableAssignmentsChart = ({ seatsioPublicKey, seatsioEventKey, region, assignments }) => {
  const colorScheme = usePageColorScheme();
  const assignmentById = useMemo(() => {
    const map = {};
    (assignments || []).forEach((a) => { map[a.seatsio_object_id] = a; });
    return map;
  }, [assignments]);

  if (!seatsioPublicKey || !seatsioEventKey) {
    return <div className="text-muted">Seating chart unavailable.</div>;
  }

  return (
    <div className="card" style={{ border: '1px solid var(--od-c-f3f3f3, #f3f3f3)', height: '515px' }}>
      <SeatsioSeatingChart
        workspaceKey={seatsioPublicKey}
        event={seatsioEventKey}
        region={region || 'na'}
        mode="static"
        colorScheme={colorScheme}
        fitTo="widthAndHeight"
        extraConfig={{ assignmentById }}
        objectLabel={(object, defaultLabel, extraConfig) => {
          // Self-contained: Seats.io stringifies this callback and runs it in
          // its renderer iframe, so the body may reference only its own params
          // and literals — never module-scope helpers or closure variables
          // (they are undefined in the iframe and abort the render). Buyer
          // assignments are passed in via extraConfig.
          const map = extraConfig?.assignmentById || {};
          const a = map[object.label] || map[object.id];
          const name = a && a.buyer_name;
          if (!name) return undefined;
          const last = name.trim().split(/\s+/).pop();
          return last.length > 12 ? `${last.slice(0, 11)}…` : last;
        }}
      />
    </div>
  );
};

TableAssignmentsChart.propTypes = {
  seatsioPublicKey: PropTypes.string,
  seatsioEventKey:  PropTypes.string,
  region:           PropTypes.string,
  assignments:      PropTypes.arrayOf(PropTypes.shape({
    seatsio_object_id: PropTypes.string.isRequired,
    buyer_name:        PropTypes.string.isRequired,
  })),
};

export default TableAssignmentsChart;
